import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionState } from '../hooks/useSessionState';
import RibbonActions from '../components/RibbonActions';
import FiltroPanel from '../components/FiltroPanel';
import { getVehiculos, getVehiculo, createVehiculo, updateVehiculo, getClientes } from '../services/api';

const TIPOS = ['auto','moto','camion','maquinaria','otro'];
const vacio = { cliente_id:'', placa:'', tipo:'auto', marca:'', linea:'', modelo_anio:'', vin:'', motor:'', color:'', cilindraje:'', combustible:'', km_actual:'', notas:'' };
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const fecha = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';

export default function Vehiculos() {
  const nav = useNavigate();
  const [lista, setLista] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [busq, setBusq] = useSessionState('veh_busq', '');
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(vacio);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [ficha, setFicha] = useState(null);   // {vehiculo, historial, recordatorios}

  const load = () => getVehiculos(busq ? { busq } : {}).then(r => setLista(r.data));
  useEffect(() => { getClientes().then(r => setClientes(r.data)).catch(() => {}); }, []);
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [busq]);

  const abrirNuevo = () => { setForm(vacio); setEditId(null); setModal(true); };
  const abrirEdit = (v) => { setForm({ ...vacio, ...v, cliente_id: v.cliente_id || '', km_actual: v.km_actual ?? '' }); setEditId(v.id); setModal(true); };

  const guardar = async () => {
    if (!form.placa) return alert('La placa es requerida');
    setSaving(true);
    try {
      if (editId) await updateVehiculo(editId, form); else await createVehiculo(form);
      setModal(false); load();
    } catch (e) { alert(e.response?.data?.error || 'Error al guardar'); }
    finally { setSaving(false); }
  };

  const verFicha = (id) => getVehiculo(id).then(r => setFicha(r.data));

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Vehículos</h1><p style={s.sub}>Parque de vehículos e historial por placa</p></div>
        <RibbonActions><div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <FiltroPanel fields={[{ tipo:'input', value:busq, onChange:setBusq, placeholder:'Buscar placa, marca…' }]} onClear={() => setBusq('')} />
          <button style={s.btnPrimary} onClick={abrirNuevo}>+ Nuevo vehículo</button>
        </div></RibbonActions>
      </div>

      <div style={s.card}>
        <table style={s.table}>
          <thead><tr>{['Placa','Tipo','Marca / Línea','Modelo','Cliente','Km','Último servicio',''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={8} style={s.empty}>Sin vehículos registrados</td></tr>}
            {lista.map(v => (
              <tr key={v.id} style={{ cursor:'pointer' }} onClick={() => verFicha(v.id)}>
                <td style={{ ...s.td }}><span style={s.placa}>{v.placa}</span></td>
                <td style={s.td}>{v.tipo}</td>
                <td style={s.td}>{[v.marca, v.linea].filter(Boolean).join(' ') || '—'}</td>
                <td style={s.td}>{v.modelo_anio || '—'}</td>
                <td style={s.td}>{v.cliente_nombre || '—'}</td>
                <td style={s.td}>{v.km_actual != null ? Number(v.km_actual).toLocaleString('es-CO') : '—'}</td>
                <td style={s.td}>{fecha(v.ultimo_servicio)}</td>
                <td style={s.td}><button style={s.editBtn} onClick={(e) => { e.stopPropagation(); abrirEdit(v); }}>Editar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal crear/editar */}
      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>{editId ? 'Editar vehículo' : 'Nuevo vehículo'}</h2>
              <button style={s.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Placa *</label>
                  <input style={s.input} value={form.placa} onChange={e => setForm({ ...form, placa:e.target.value.toUpperCase() })} /></div>
                <div style={s.field}><label style={s.label}>Tipo</label>
                  <select style={s.input} value={form.tipo} onChange={e => setForm({ ...form, tipo:e.target.value })}>{TIPOS.map(t => <option key={t} value={t}>{t}</option>)}</select></div>
              </div>
              <div style={s.field}><label style={s.label}>Cliente / propietario</label>
                <select style={s.input} value={form.cliente_id} onChange={e => setForm({ ...form, cliente_id:e.target.value })}>
                  <option value="">— Sin asignar —</option>
                  {clientes.map(c => <option key={c.id} value={c.id}>{c.razon_social}</option>)}
                </select></div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Marca</label>
                  <input style={s.input} value={form.marca} onChange={e => setForm({ ...form, marca:e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Línea</label>
                  <input style={s.input} value={form.linea} onChange={e => setForm({ ...form, linea:e.target.value })} /></div>
              </div>
              <div style={s.row3}>
                <div style={s.field}><label style={s.label}>Modelo (año)</label>
                  <input style={s.input} type="number" value={form.modelo_anio} onChange={e => setForm({ ...form, modelo_anio:e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Color</label>
                  <input style={s.input} value={form.color} onChange={e => setForm({ ...form, color:e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Km actual</label>
                  <input style={s.input} type="number" value={form.km_actual} onChange={e => setForm({ ...form, km_actual:e.target.value })} /></div>
              </div>
              <div style={s.row3}>
                <div style={s.field}><label style={s.label}>VIN / Serial</label>
                  <input style={s.input} value={form.vin} onChange={e => setForm({ ...form, vin:e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Motor</label>
                  <input style={s.input} value={form.motor} onChange={e => setForm({ ...form, motor:e.target.value })} /></div>
                <div style={s.field}><label style={s.label}>Cilindraje</label>
                  <input style={s.input} value={form.cilindraje} onChange={e => setForm({ ...form, cilindraje:e.target.value })} /></div>
              </div>
              <div style={s.field}><label style={s.label}>Notas</label>
                <textarea style={{ ...s.input, minHeight:52, resize:'vertical', height:'auto', padding:'8px 12px' }} value={form.notas} onChange={e => setForm({ ...form, notas:e.target.value })} /></div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={guardar} disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Ficha / historial */}
      {ficha && (
        <div style={s.overlay} onClick={() => setFicha(null)}>
          <div style={s.drawer} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}><span style={s.placa}>{ficha.placa}</span> {[ficha.marca, ficha.linea].filter(Boolean).join(' ')}</h2>
              <button style={s.closeBtn} onClick={() => setFicha(null)}>✕</button>
            </div>
            <div style={s.modalBody}>
              <div style={s.fichaGrid}>
                <Dato k="Cliente" v={ficha.cliente_nombre || '—'} />
                <Dato k="Modelo" v={ficha.modelo_anio || '—'} />
                <Dato k="Km actual" v={ficha.km_actual != null ? Number(ficha.km_actual).toLocaleString('es-CO') : '—'} />
                <Dato k="VIN" v={ficha.vin || '—'} />
                <Dato k="Color" v={ficha.color || '—'} />
                <Dato k="Cilindraje" v={ficha.cilindraje || '—'} />
              </div>

              {ficha.recordatorios?.length > 0 && (
                <>
                  <h4 style={s.secTitle}>Recordatorios pendientes</h4>
                  {ficha.recordatorios.map(r => (
                    <div key={r.id} style={s.recRow}><b style={{ color:'#e2e8f0' }}>{r.tipo}</b>
                      <span style={{ color:'#64748b', marginLeft:8 }}>{r.proximo_km ? `a los ${Number(r.proximo_km).toLocaleString('es-CO')} km` : ''} {r.proxima_fecha ? `· ${fecha(r.proxima_fecha)}` : ''}</span></div>
                  ))}
                </>
              )}

              <h4 style={s.secTitle}>Historial de servicios</h4>
              {(!ficha.historial || ficha.historial.length === 0) && <div style={s.empty}>Sin servicios registrados</div>}
              {ficha.historial?.map(o => (
                <div key={o.id} style={s.histRow} onClick={() => { setFicha(null); nav(`/taller/${o.id}`); }}>
                  <div><span style={{ color:'#93c5fd', fontWeight:600 }}>{o.numero}</span> <span style={{ color:'#64748b', fontSize:12 }}>{fecha(o.fecha_entrada)}</span></div>
                  <div style={{ color:'#94a3b8', fontSize:12 }}>{o.motivo || '—'}</div>
                  <div style={{ color:'#10b981', fontSize:12, fontWeight:600 }}>{fmt(o.total)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const Dato = ({ k, v }) => (<div><div style={{ color:'#64748b', fontSize:11 }}>{k}</div><div style={{ color:'#e2e8f0', fontSize:13 }}>{v}</div></div>);

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032' },
  td:          { padding:'8px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332' },
  placa:       { background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:4, padding:'2px 8px', fontSize:12, fontWeight:700, letterSpacing:0.5 },
  editBtn:     { background:'#0f172a', border:'1px solid #334155', color:'#93c5fd', borderRadius:6, padding:'3px 10px', fontSize:12, cursor:'pointer' },
  empty:       { padding:'24px', textAlign:'center', color:'#475569', fontSize:13 },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:620, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  drawer:      { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:560, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0, display:'flex', alignItems:'center', gap:10 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  row3:        { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  fichaGrid:   { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginBottom:12 },
  secTitle:    { color:'#cbd5e1', fontSize:13, fontWeight:600, margin:'14px 0 8px', borderTop:'1px solid #334155', paddingTop:12 },
  recRow:      { background:'#0f172a', border:'1px solid #243044', borderRadius:6, padding:'6px 10px', fontSize:13, marginBottom:6 },
  histRow:     { display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, background:'#0f172a', border:'1px solid #243044', borderRadius:8, padding:'8px 12px', marginBottom:6, cursor:'pointer' },
};
